module.exports = __webpack_public_path__ + "img/exmpl-ui_claim-blocks.d06cb351.png";